import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative; // Mantém relative para outros filhos, se necessário, mas não mais para AddressesOptions
  width: 100%;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 300px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 400px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: ${400 / 16}rem;
  }

  > button {
    display: flex;
    height: 50px;
    border-radius: 50px;
    margin-top: 16px;
    align-items: center;
    justify-content: center;
    padding: 8px;
    font-size: 14px;
    width: 100%;
    border: 0;
    background: #6ea5ff;
    font-weight: 600;
    color: #fff;
  }
`;

export const InputWrapper = styled.div`
  background-color: hsla(219, 100%, 97%, 0.3);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid hsla(219, 100%, 5%, 0.3);
  padding: 16px 12px;
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  svg {
    color: ${({ theme }) => theme.palette.primary.blue900};
    width: ${20 / 16}rem;
    height: ${20 / 16}rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
      width: ${16 / 16}rem;
      height: ${16 / 16}rem;
    }
  }
`;

export const Input = styled.input`
  border: 0;
  width: 100%;
  font-size: ${14 / 16}rem;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  background-color: inherit;
  color: ${({ theme }) => theme.palette.black.default};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${12 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${12 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${14 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopTxl}) {
    font-size: ${16 / 16}rem;
  }
`;

export const AddressesOptions = styled.div`
  position: absolute; 
  z-index: 1000; 
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15),
    0px 4px 32px 0px rgba(0, 0, 0, 0.1);

`;

export const AddressesOptionsContent = styled.div`
  overflow-y: auto; 
  overflow-x: hidden; 
  width: 100%; 

  @media (max-width: 767px) {
    padding: 6px 0px;
    min-height: 60px;
    max-height: 200px;
  }

  @media (min-width: 768px) {
    padding: 6px 0px;
    min-height: 60px;
    max-height: 200px;
  }

  @media (min-width: 1441px) {
    padding: 6px 0px;
    min-height: 60px;
    max-height: 200px;
  }
`;

export const EmptyAddressesOptions = styled.div`
  padding: 10px 20px;
  font-size: 16px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const OptionsContant = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  &:hover,
  &:focus {
    background-color: rgb(248, 249, 245);
  }

  > svg {
    margin-left: 20px;
    color: #ccc;
  }

  > button {
    border: 0;
    background: transparent;
    width: 100%;
    text-align: left;
    padding: 14px 10px;

    > p {
      font-size: 14px;
    }

    & + button {
      margin-top: 4px;
    }

    @media (max-width: 767px) {
      text-align: initial;
      font-size: 14px;
    }

    @media (min-width: 1441px) {
      > p {
        font-size: 16px;
      }
    }
  }
`;